import React, { useEffect, useState } from "react";
import {
    getWalletDetails,
    getLatestRecharges,
    getLatestUsed
} from "../../../services/payment/api";
import "./ClientWallet.css";

const ClientWallet = () => {

    const [wallet, setWallet] = useState(null);
    const [loading, setLoading] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [transactions, setTransactions] = useState([]);

    useEffect(() => {
        fetchWallet();
    }, []);

    const fetchWallet = async () => {
        try {
            setLoading(true);
            const data = await getWalletDetails();
            setWallet(data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const openRechargePopup = async (title) => {
        try {
            const data = await getLatestRecharges();
            setTransactions(data);
            setModalTitle(title);
            setShowModal(true);
        } catch (e) {
            console.error(e);
        }
    };

    const openUsedPopup = async () => {
        try {
            const data = await getLatestUsed();
            setTransactions(data);
            setModalTitle("Latest Used Transactions");
            setShowModal(true);
        } catch (e) {
            console.error(e);
        }
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div className="wallet-container">

            <h2>Client Wallet</h2>

            {wallet && (

                <div className="wallet-cards">

                    <div className="wallet-card">
                        <h4>Current Balance</h4>
                        <p className="amount">₹ {wallet.currentBalance}</p>
                    </div>

                    <div
                        className="wallet-card clickable"
                        onClick={() => openRechargePopup("Latest Recharge Transactions")}
                    >
                        <h4>Total Recharged</h4>
                        <p>₹ {wallet.totalRecharged}</p>
                    </div>

                    <div
                        className="wallet-card clickable"
                        onClick={openUsedPopup}
                    >
                        <h4>Total Used</h4>
                        <p>₹ {wallet.totalUsed}</p>
                    </div>

                    <div
                        className="wallet-card clickable"
                        onClick={() => openRechargePopup("Recharge History")}
                    >
                        <h4>Recent Transaction</h4>
                        <p>{wallet.rechargeCount}</p>
                    </div>

                    <div className="wallet-card">
                        <h4>Last Recharge</h4>
                        <p>
                            {wallet.lastRechargeDate
                                ? new Date(wallet.lastRechargeDate).toLocaleDateString()
                                : "-"}
                        </p>
                    </div>

                </div>
            )}

            {showModal && (
                <div className="wallet-modal-overlay">
                    <div className="wallet-modal">

                        <div className="wallet-modal-header">
                            <h3>{modalTitle}</h3>

                            <button
                                className="close-btn"
                                onClick={() => setShowModal(false)}
                            >
                                ×
                            </button>
                        </div>

                        <table className="wallet-table">

                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Amount</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                </tr>
                            </thead>

                            <tbody>

                                {transactions.length === 0 ? (

                                    <tr>
                                        <td colSpan="5">
                                            No Records Found
                                        </td>
                                    </tr>

                                ) : (

                                    transactions.map(item => (

                                        <tr key={item.transactionId}>
                                            <td>{item.transactionId}</td>
                                            <td>₹ {item.credits}</td>
                                            <td>{item.description}</td>
                                            <td>{item.status}</td>
                                            <td>
                                                {new Date(item.createdDate).toLocaleString()}
                                            </td>
                                        </tr>

                                    ))

                                )}

                            </tbody>

                        </table>

                    </div>
                </div>
            )}

        </div>
    );
};

export default ClientWallet;